import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import AllPackagesPageData from 'app/Models/Content/AllPackagesPageData';
import React from 'react';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';
import {isMobile} from 'react-device-detect';
import {Container} from 'reactstrap';

export default class AllPackagesPage extends Page<AllPackagesPageData> {
  render() {
    const {
      data: {mainContentArea, title, subTitle, backgroundImage, backgroundMobileImage},
      context,
    } = this.props;

    return (
      <div className='AllPackagesPage'>
        <div {...getBackgroundImageProps(isMobile ? backgroundMobileImage : backgroundImage, context)} className='AllPackagesPage__header'>
          <Container>
            <div className='AllPackagesPage__header__title-and-subtitle'>
              {title.value.length > 0 && <div className='AllPackagesPage__header__title-and-subtitle__title'>{title.value}</div>}
              {subTitle.value.length > 0 && <div className='AllPackagesPage__header__title-and-subtitle__subtitle'>{subTitle.value}</div>}
            </div>
          </Container>
        </div>

        <div className='TVPricingItemsBlock__items container'>
          <ContentArea noWrap context={context} data={mainContentArea} />
        </div>
      </div>
    );
  }
}
